import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonRow,
    IonCol,
    IonButton,
    IonItem,
    IonThumbnail,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonCheckbox,
    IonAlert,
    IonAccordion,
    IonAccordionGroup,
    IonSearchbar
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline, createOutline, trashOutline, add, closeOutline, eyeOutline, search } from 'ionicons/icons';
import PosActions from '../../../actions/PosActions';
import ProductActions from '../../../actions/ProductActions';
import { getDominio, getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { types } from 'util';
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;

}

interface IState {
    datalogin: any;
    pages: number;
    pageSize: number;
    total_rows: number;
    searchText: string;
    current_count_data: number;
    productsDB: any;
    data_pagin_productsDB: any;
    dominio: any;
    currencyprimary: any;
    currencysecondary: any;
    fieldsproduct: any;
    ModalproductShow: any;
    formErrors: any;
    categories: any;
    subcategories: any;
    sub_subcategories: any;
    units: any;
    brands: any;
    products_types: any;
    alertDestroy: any;

    categoriesDB: any;
    subcategoriesDB: any;
    sub_subcategoriesDB: any;
    brandsDB: any;

    filter_categories: any;
    filter_subcategories: any;
    filter_sub_subcategories: any;
    filter_brands: any;
    variationsDB: any;
    locationsDB: any;

    product_locations_stock: any;
    ModalListStockShow: any;
}

const options2: any = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

class listProduct extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    Modalproduct: React.RefObject<HTMLIonModalElement>;
    ModalListStockShow: React.RefObject<HTMLIonModalElement>;
    constructor(props: any) {
        super(props)
        this.Modalproduct = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.ModalListStockShow = React.createRef<HTMLIonModalElement>();
        this.state = {
            datalogin: {},
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            productsDB: [],
            data_pagin_productsDB: [],
            dominio: null,
            currencyprimary: props.currencyprimary,
            currencysecondary: props.currencysecondary,
            fieldsproduct: null,
            ModalproductShow: false,
            formErrors: {},
            categories: [],
            subcategories: [],
            sub_subcategories: [],
            units: [],
            brands: [],
            products_types: [
                { name: 'Unitario', id: 'single' },
                { name: 'Variable', id: 'variable' }
            ],
            alertDestroy: false,

            filter_categories: null,
            filter_subcategories: null,
            filter_sub_subcategories: null,
            filter_brands: null,
            categoriesDB: [],
            brandsDB: [],
            subcategoriesDB: [],
            sub_subcategoriesDB: [],
            variationsDB: [],
            locationsDB: [],
            product_locations_stock: [],
            ModalListStockShow: false
        }
    }

    componentDidMount() {
        this.setState({
            datalogin: getLoginApp(),
            dominio: getDominio(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            ModalListStockShow: false,
            fieldsproduct: {
                id: null,
                name: '',
                sku: '',
                category_id: null,
                sub_category_id: null,
                sub_sub_category_id: null,
                unit_id: null,
                brand_id: null,
                type: 'single',
                single_dpp_inc_tax: 0,
                single_dsp_inc_tax: 0,
                variations: [
                    {
                        variation_id: null,
                        values: [],
                        values_variations: []
                    }
                ],
                locations: []
            },
            ModalproductShow: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }
        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_products',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_products/listProduct',

            category_id: this.state.filter_categories ? this.state.filter_categories : null,
            sub_category_id: this.state.filter_subcategories ? this.state.filter_subcategories : null,
            sub_subcategory_id: this.state.filter_sub_subcategories ? this.state.filter_sub_subcategories : null,

            brand_id: this.state.filter_brands ? this.state.filter_brands : null
        }, "api/get_list_products");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        let current_count_data_prev = this.state.current_count_data;
        if (nextProps.data.data_pagin_productsDB && nextProps.data.data_pagin_productsDB.length > 0 && nextProps.data.view_active == "dashboard_products/listProduct") {
            if (current_count_data_prev < nextProps.data.data_pagin_productsDB.length) {
                if (this.ionInfiniteScrollRefData.current) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

        this.setState({
            productsDB: nextProps.data.productsDB && nextProps.data.productsDB ? nextProps.data.productsDB : [],
            data_pagin_productsDB: nextProps.data.data_pagin_productsDB && nextProps.data.data_pagin_productsDB ? nextProps.data.data_pagin_productsDB : [],
            pages: nextProps.data.productsDB && nextProps.data.productsDB.pages ? nextProps.data.productsDB.pages : 0,
            total_rows: nextProps.data.productsDB && nextProps.data.productsDB.total_rows ? nextProps.data.productsDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_productsDB ? nextProps.data.data_pagin_productsDB.length : 0,
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            categories: nextProps.data.data_default && nextProps.data.data_default.categories ? nextProps.data.data_default.categories : [],
            units: nextProps.data.data_default && nextProps.data.data_default.units ? nextProps.data.data_default.units : [],
            brands: nextProps.data.data_default && nextProps.data.data_default.brands ? nextProps.data.data_default.brands : [],

            categoriesDB: nextProps.data.data_default && nextProps.data.data_default.categories ? nextProps.data.data_default.categories : [],
            brandsDB: nextProps.data.data_default && nextProps.data.data_default.brands ? nextProps.data.data_default.brands : [],
            variationsDB: nextProps.data.data_default && nextProps.data.data_default.variations ? nextProps.data.data_default.variations : [],

            locationsDB: nextProps.data.data_default && nextProps.data.data_default.businessLocations ? nextProps.data.data_default.businessLocations : [],

            product_locations_stock: nextProps.data.product_locations_stock && nextProps.data.product_locations_stock ? nextProps.data.product_locations_stock : [],
            ModalListStockShow: nextProps.data.product_locations_stock && nextProps.data.product_locations_stock.length > 0 ? true : false,
        });
        if (nextProps.data.view_active == "dashboard_products/listProduct") {

            if (nextProps.data.refresh_list) {

                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
        }
    }

    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }

    errorimg(e: any, row: any) {
        e.target.src = 'assets/img/default.jpg';
    }

    render_products(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonItem>
                    <IonThumbnail slot="start">
                        <img onError={e => this.errorimg(e, row)} style={{ textAlign: 'center', width: "100%" }} src={this.state.dominio + 'uploads/img/' + row.product_image} />
                    </IonThumbnail>
                    <IonRow style={{ width: '100%' }}>
                        <IonCol col-12 size='12'>
                            <label className='text-sm font-medium text-g60'><strong> {row.product ?? ''}</strong></label>
                            <br />
                            <label className='text-sm font-medium text-g60'><strong>SKU: </strong>{row.sku ?? ''}</label>&nbsp;
                            <label className='text-sm font-medium text-g60'><strong>STOCK: </strong>{row.current_stock ? _numberFormat.format(row.current_stock).replace("$", '') : '--'}</label>&nbsp;
                            <label className='text-sm font-medium text-g60'>{row.unit ?? ''}</label>
                        </IonCol>
                        <IonCol col-5 size='5'>
                            <strong>{_numberFormat.format(row.max_price).replace("$", this.state.currencyprimary)}</strong>
                        </IonCol>
                        <IonCol col-7 size='7' className='text-right'>
                            <IonButton size='small' onClick={(e) => this.getlocationstockproducts(row)}>
                                <div>
                                    <IonIcon
                                        color="#ffffff"
                                        slot="icon-only"
                                        icon={eyeOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                        size="small"
                                    />
                                </div>
                            </IonButton>
                            <IonButton size='small' onClick={(e) => this.openModalproducts(e, row)}>
                                <div>
                                    <IonIcon
                                        color="#ffffff"
                                        slot="icon-only"
                                        icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                        size="small"
                                    />
                                </div>
                            </IonButton>
                            <IonButton size='small' color={'danger'}
                                onClick={
                                    e => this.setState({ alertDestroy: true, fieldsproduct: row })
                                }>
                                <div>
                                    <IonIcon
                                        color="light"
                                        slot="icon-only"
                                        icon={trashOutline}
                                        size="small"
                                    />
                                </div>
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonItem>

            </div >
        );
    }

    openModalproducts(e: any, row: any) {
        let subcategories = [];
        let sub_subcategories = [];
        if (row && row.category_id) {
            subcategories = this.state.categories.filter((item: any) => item.id == row.category_id)[0].sub_categories;
        }
        if (row && row.sub_category_id) {
            sub_subcategories = subcategories.filter((item: any) => item.id == row.sub_category_id)[0].sub_sub_categories;
        }

        let variations: any = [];
        if (row && row.type == 'variable' && row.variations && row.variations.length > 0) {
            row.variations.map((val: any, key: any) => {
                // asegurar que las variaciones/valores del producto existan en variationsDB, si no, insertarlos
                let exist_variation_id = false;
                let variations_filter = variations.filter((item: any) =>
                    item.variation_id == val.variation_value.variation_template_id &&
                    item.product_variation_id == val.product_variation_id
                );

                if (variations_filter && variations_filter.length > 0) {
                    exist_variation_id = true;
                    let values: any = [];
                } else {
                    variations.push({
                        variation_id: val.variation_value.variation_template_id ?? null,
                        product_id: val.product_id ?? null,
                        values: [],
                        values_variations: [],
                        values_edit: [],
                        product_variation_id: val.product_variation_id,
                    });
                }
            });

            variations.map((val: any, key: any) => {
                row.variations.map((val_: any, key: any) => {
                    let variation_template_id = val_.variation_value.variation_template_id;
                    let exist_value_id = false;
                    let values_filter = val.values.filter((item: any) =>
                        item.id == val_.variation_value_id &&
                        item.variation_template_id == variation_template_id &&
                        val.variation_id == variation_template_id
                    );

                    if (values_filter && values_filter.length > 0) {
                        exist_value_id = true;
                    } else {
                        if (val.variation_id == variation_template_id && val_.product_variation_id == val.product_variation_id) {
                            val.values.push({
                                id: val_.variation_value_id,
                                variation_id: val_.id,
                                name: val_.name,
                                variation_template_id: val_.variation_value.variation_template_id
                            });

                            val.values_edit.push({
                                value: val_.variation_value_id,
                                label: val_.name,
                            });

                            val.values_variations.push({
                                id: val_.variation_value_id,
                                variation_id: val_.id,
                                label: val_.name,
                                valor: val_.name,
                                dpp_inc_tax: val_.default_purchase_price,
                                dsp_inc_tax: val_.default_sell_price
                            });

                        }
                    }
                });
            });

            variations.map((val: any, key: any) => {
                // buscar la variación seleccionada en el catálogo de variaciones
                const selectedVar = this.state.variationsDB ? this.state.variationsDB.find((v: any) => v.id == val.variation_id) : null;
                // posible claves donde estén los valores dentro del objeto de variación
                const candidateValues = selectedVar ? selectedVar.values : [];
                // asignar el arreglo "variations" con los valores crudos encontrados
                val['values'] = Array.isArray(candidateValues) ? candidateValues : [];
            });
        }

        let locations: any = [];

        // Construir lista base de locaciones (preferir locationsDB, si no usar las de row)
        const baseLocations = (this.state.locationsDB && this.state.locationsDB.length > 0)
            ? this.state.locationsDB
            : (row && Array.isArray(row.locations) ? row.locations : []);

        // Para cada locación, buscar transacciones de opening_stock asociadas y mapear valores
        // Si el producto es variable, crear una entrada por cada variación + por cada locación
        if (row && row.type === 'variable' && Array.isArray(row.variations) && row.variations.length > 0) {
            row.variations.forEach((v: any) => {
                const variationId = v.id ?? v.variation_value_id ?? v.id ?? null;
                const prodId = v.product_id ?? row?.id ?? null;

                baseLocations.forEach((loc: any) => {
                    const locId = loc.id ?? loc.location_id;
                    if (!locId) return;
                    const locName = loc.name ?? loc.location_name ?? '';

                    // filtrar transacciones de apertura relacionadas a esta locación y variación
                    const transactions = Array.isArray(row?.opening_stock_transactions)
                        ? row.opening_stock_transactions.filter((t: any) =>
                            t.location_id == locId &&
                            (
                                // varios posibles campos donde pueda venir la referencia a la variación
                                (variationId != null && (t.product_variation_id == variationId || t.variation_id == variationId || t.variation_value_id == variationId)) ||
                                // si no hay variationId, aceptar transacción sin relación a variación
                                (variationId == null && (t.product_variation_id == null && t.variation_id == null && t.variation_value_id == null))
                            )
                        )
                        : [];

                    const t = transactions.length > 0 ? transactions[0] : null;

                    locations.push({
                        location_id: locId,
                        location_name: locName,
                        variation_name: v.name ?? '',
                        quantity: t ? (Number(t.quantity) || 0) : (loc.quantity ?? 0),
                        purchase_price: t ? (Number(t.purchase_price) || 0) : (loc.purchase_price ?? 0),
                        purchase_line_id: t ? (t.purchase_line_id ?? t.purchase_line?.id ?? null) : null,
                        product_id: prodId,
                        variation_id: variationId
                    });
                });
            });
        } else {
            // producto simple: una entrada por locación (variation_id = null)
            baseLocations.forEach((loc: any) => {
                const locId = loc.id ?? loc.location_id;
                if (!locId) return; // saltar si no hay ID de locación válido
                const locName = loc.name ?? loc.location_name ?? '';

                // filtrar transacciones de apertura relacionadas a esta locación
                const transactions = Array.isArray(row?.opening_stock_transactions)
                    ? row.opening_stock_transactions.filter((t: any) => t.location_id == locId)
                    : [];

                // tomar la primera transacción (si hay) y usar sus valores; si no, usar valores por defecto
                const t = transactions.length > 0 ? transactions[0] : null;

                locations.push({
                    location_id: locId,
                    location_name: locName,
                    quantity: t ? (Number(t.quantity) || 0) : (loc.quantity ?? 0),
                    purchase_price: t ? (Number(t.purchase_price) || 0) : (loc.purchase_price ?? 0),
                    purchase_line_id: t ? (t.purchase_line_id ?? t.purchase_line?.id ?? null) : null,
                    product_id: row?.id ?? null,
                    variation_id: row && row.variations && row.variations.length > 0 ? (row.variations[0].id ?? row.variations[0].variation_value_id ?? null) : null,
                });
            });
        }


        let fieldsproduct = {
            id: (row && row.id) ?? null,
            name: (row && row.product) ?? '',
            sku: (row && row.sku) ?? '',
            category_id: (row && row.category_id) ?? null,
            sub_category_id: (row && row.sub_category_id) ?? null,
            sub_sub_category_id: (row && row.sub_sub_category_id) ?? null,
            unit_id: (row && row.unit_id) ?? 1,
            brand_id: (row && row.brand_id) ?? null,
            type: (row && row.type) ?? 'single',
            single_dpp_inc_tax: (row && row.max_purchase_price) ?? 0,
            single_dsp_inc_tax: (row && row.max_price) ?? 0,
            enable_stock: (row && row.enable_stock) ?? 1,
            variations: variations,
            locations: locations
        };

        this.setState({
            ModalproductShow: true,
            subcategories: subcategories ?? [],
            sub_subcategories: sub_subcategories ?? [],
            fieldsproduct: fieldsproduct
        });
    }

    dismissModalproducts() {
        this.setState({
            ModalproductShow: false,
            fieldsproduct: {
                id: null,
                name: '',
                sku: '',
                category_id: null,
                sub_category_id: null,
                sub_sub_category_id: null,
                unit_id: null,
                brand_id: null,
                type: 'single',
                single_dpp_inc_tax: 0,
                single_dsp_inc_tax: 0,
                variations: [
                    {
                        variation_id: null,
                        values: [],
                        values_variations: []
                    }
                ]
            }
        });
    }

    handleChangeproduct(event: any) {
        let fieldsproduct = this.state.fieldsproduct;
        fieldsproduct[event.target.name] = event.target.value;

        let subcategories = this.state.subcategories;
        let sub_subcategories = this.state.sub_subcategories;

        if (event.target.name == 'category_id') {
            if (event.target.value == null || event.target.value == '') {
                subcategories = [];
                fieldsproduct['sub_category_id'] = null;
                fieldsproduct['sub_sub_category_id'] = null;
                sub_subcategories = [];
            } else {
                subcategories = this.state.categories.filter((item: any) => item.id == event.target.value)[0].sub_categories;
                fieldsproduct['sub_category_id'] = null;
                fieldsproduct['sub_sub_category_id'] = null;
                sub_subcategories = [];
            }

        }

        if (event.target.name == 'sub_category_id') {
            let category_id = fieldsproduct['category_id'];
            subcategories = this.state.categories.length > 0 ? this.state.categories.filter((item: any) => item.id == category_id) : [];
            subcategories = subcategories.length > 0 ? subcategories[0].sub_categories : [];
            subcategories = subcategories && subcategories.length > 0 ? subcategories : [];

            if (event.target.value == null || event.target.value == '') {
                sub_subcategories = [];
                fieldsproduct['sub_category_id'] = null;
                fieldsproduct['sub_sub_category_id'] = null;
            } else {
                sub_subcategories = this.state.subcategories.length > 0 ? subcategories.filter((item: any) => item.id == event.target.value)[0].sub_sub_categories : [];
                fieldsproduct['sub_sub_category_id'] = null;
            }

        }

        if (event.target.name == 'sub_sub_category_id') {
            let sub_category_id = fieldsproduct['sub_category_id'];
            sub_subcategories = this.state.subcategories.length > 0 ? this.state.subcategories.filter((item: any) => item.id == sub_category_id) : [];
            sub_subcategories = sub_subcategories.length > 0 ? sub_subcategories[0].sub_sub_categories : [];
        }

        this.setState({
            fieldsproduct: fieldsproduct,
            subcategories: subcategories ?? [],
            sub_subcategories: sub_subcategories ?? []
        });
    }

    SaveDataPost() {
        let fieldsproduct = this.state.fieldsproduct;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsproduct && this.state.fieldsproduct.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };
        if (this.state.fieldsproduct && (this.state.fieldsproduct.unit_id == null || this.state.fieldsproduct.unit_id == '')) { formErrors['unit_id'] = "*Campo Requerido"; error = true };
        if (this.state.fieldsproduct && (this.state.fieldsproduct.type == 'single')) {
            if (this.state.fieldsproduct && (this.state.fieldsproduct.single_dpp_inc_tax == null || this.state.fieldsproduct.single_dpp_inc_tax == '' || isNaN(this.state.fieldsproduct.single_dpp_inc_tax))) { formErrors['single_dpp_inc_tax'] = "*Campo Requerido"; error = true }
            if (this.state.fieldsproduct && (this.state.fieldsproduct.single_dsp_inc_tax == null || this.state.fieldsproduct.single_dsp_inc_tax == '' || isNaN(this.state.fieldsproduct.single_dsp_inc_tax))) { formErrors['single_dsp_inc_tax'] = "*Campo Requerido"; error = true };
        }

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsproduct.id && fieldsproduct.id != null) {
                this.props.post_({
                    typeOption: 'updateDataproduct',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsproduct: this.state.fieldsproduct,
                    view_active: 'dashboard_products/listProduct'
                }, "api/updateDataproduct");
            } else {
                this.props.post_({
                    typeOption: 'saveDataproduct',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsproduct: this.state.fieldsproduct,
                    view_active: 'dashboard_products/listProduct'
                }, "api/saveDataproduct");
            }
            this.setState({
                ModalproductShow: false,
            });
        }

    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDataproduct',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsproduct: this.state.fieldsproduct,
            view_active: 'dashboard_products/listProduct'
        }, "api/destroyDataproduct");
        this.setState({
            alertDestroy: false
        });
    }

    handleChangeState(event: any) {
        console.log(event.target.value, 'event.target.value');

        let subcategories = this.state.subcategoriesDB;
        let sub_subcategories = this.state.sub_subcategoriesDB;

        let filter_categories = this.state.filter_categories;
        let filter_subcategories = null;
        let filter_sub_subcategories = null;

        if (event.target.name == 'filter_categories') {
            if (event.target.value == null || event.target.value == '') {
                subcategories = [];
                sub_subcategories = [];
                filter_subcategories = null;
                filter_sub_subcategories = null;
            } else {
                subcategories = this.state.categoriesDB.filter((item: any) => item.id == event.target.value)[0].sub_categories;
                sub_subcategories = [];
            }
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,
                subcategoriesDB: subcategories ?? [],
                sub_subcategoriesDB: sub_subcategories ?? [],

                filter_subcategories: null,
                filter_sub_subcategories: null,

            });
        }

        if (event.target.name == 'filter_subcategories') {
            let category_id = filter_categories;
            subcategories = this.state.categoriesDB.length > 0 ? this.state.categoriesDB.filter((item: any) => item.id == category_id) : [];
            subcategories = subcategories.length > 0 ? subcategories[0].sub_categories : [];
            subcategories = subcategories && subcategories.length > 0 ? subcategories : [];

            if (event.target.value == null || event.target.value == '') {
                sub_subcategories = [];
                filter_sub_subcategories = null;
            } else {
                sub_subcategories = subcategories.length > 0 ? subcategories.filter((item: any) => item.id == event.target.value)[0].sub_sub_categories : [];
                filter_sub_subcategories = null;
            }

            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,
                sub_subcategoriesDB: sub_subcategories ?? [],

                filter_sub_subcategories: filter_sub_subcategories,

            });

        }

        if (event.target.name == 'filter_brands') {
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,

            });

        }

        if (event.target.name == 'filter_sub_subcategories') {
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,

            });
        }
        this.setState({
            pages: 0,
            pageSize: 10,
        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    handleChangeproductvariation(event: any) {
        let fieldsproduct = this.state.fieldsproduct;
        let variations = fieldsproduct.variations;
        const key = event.target.key;
        const name = event.target.name;
        const value = event.target.value;
        let new_variations: any = [];
        if (name === 'values_variations') {
            let values_ids_validos: any = [];
            value.map((val: any, k: any) => {
                values_ids_validos.push(val.value);
            });
            let new_variations: any = [];
            variations.map((val: any, k: any) => {
                if (k == key) {
                    let new_values_variations: any = [];
                    val.values_variations.map((vv: any, kv: any) => {
                        if (values_ids_validos.indexOf(vv.id) >= 0) {
                            new_values_variations.push(vv);

                        }
                    });
                    val[name] = new_values_variations;
                    new_variations.push(val);
                } else {
                    new_variations.push(val);
                }
            });
            // construir new_variations preservando los valores seleccionados y agregando los que faltan
            values_ids_validos = [];
            if (Array.isArray(value)) {
                value.forEach((valSel: any) => { values_ids_validos.push(valSel.value); });
            }
            new_variations = [];
            variations.map((val: any, k: any) => {
                if (k == key) {
                    // conservar los valores existentes que siguen seleccionados
                    let kept_values_variations = Array.isArray(val.values_variations)
                        ? val.values_variations.filter((vv: any) => values_ids_validos.indexOf(vv.id) >= 0)
                        : [];
                    // agregar los seleccionados que no existían antes
                    values_ids_validos.forEach((selId: any) => {
                        if (!kept_values_variations.find((vv: any) => vv.id == selId)) {
                            // intentar obtener info desde val.values (catálogo de valores)
                            const valueInfo = Array.isArray(val.values) ? val.values.find((v: any) => v.id == selId) : null;
                            kept_values_variations.push({
                                id: selId,
                                variation_id: val.id ?? val.variation_id ?? null,
                                label: valueInfo ? (valueInfo.name ?? valueInfo.label ?? '') : '',
                                valor: valueInfo ? (valueInfo.name ?? '') : '',
                                dpp_inc_tax: 0,
                                dsp_inc_tax: 0,
                                is_new: true // marcar como nuevo para el backend
                            });
                        }
                    });
                    // actualizar helpers (valores para el select multiselección)
                    val.values_variations = kept_values_variations;
                    val.values_edit = kept_values_variations.map((vv: any) => ({ value: vv.id, label: vv.label }));
                    new_variations.push(val);
                } else {
                    new_variations.push(val);
                }
            });
            fieldsproduct.variations = new_variations;
            this.setState({
                ...this.state,
                fieldsproduct
            });
        } else {
            variations.map((val: any, k: any) => {
                if (k == key) {
                    val[name] = value;
                    if (name === 'variation_id') {
                        // buscar la variación seleccionada en el catálogo de variaciones
                        const selectedVar = this.state.variationsDB ? this.state.variationsDB.find((v: any) => v.id == value) : null;
                        // posible claves donde estén los valores dentro del objeto de variación
                        const candidateValues = selectedVar ? selectedVar.values : [];
                        // asignar el arreglo "variations" con los valores crudos encontrados
                        val['values'] = Array.isArray(candidateValues) ? candidateValues : [];
                    } else if (name === 'dpp_inc_tax' || name === 'dsp_inc_tax') {
                        const key_value = event.target.key_value;
                        const numeric = parseFloat(value);
                        val.values_variations = val.values_variations.map((vv: any, kv: any) => {
                            if (kv === key_value) {
                                vv[name] = numeric;
                            }
                            return vv;
                        });
                    }
                    new_variations.push(val);
                } else {
                    new_variations.push(val);
                }
            });
            fieldsproduct.variations = new_variations;
            this.setState({
                ...this.state,
                fieldsproduct
            });
        }
    }

    addproductvariation() {
        let fieldsproduct = this.state.fieldsproduct;
        fieldsproduct.variations.push({
            variation_id: null,
            values_variations: [],
            values: [],
            is_new: true
        });
        this.setState({
            ...this.state,
            fieldsproduct
        });
    }

    deleteproductvariation(key: any) {
        const fieldsproduct = { ...this.state.fieldsproduct };
        const variations = Array.isArray(fieldsproduct.variations) ? [...fieldsproduct.variations] : [];
        variations.splice(key, 1);
        // mantener al menos una variación vacía si se eliminan todas
        if (variations.length === 0) {
            variations.push({ variation_id: null, values: [], values_variations: [] });
        }
        fieldsproduct.variations = variations;
        this.setState({ fieldsproduct });
    }

    handleFocus(event: any) {
        event.target.select();
    }

    renderopeningstock(locationsDB: any) {
        let fieldsproduct = this.state.fieldsproduct;
        let locations_product: any = [];
        locationsDB.map((val: any, key: any) => {
            if (val.id) {
                locations_product.push({
                    location_id: val.id,
                    location_name: val.name,
                    quantity: 0,
                    purchase_price: 0,
                    purchase_line_id: null
                });
            }

        });

        fieldsproduct.locations = locations_product;
        this.setState({ fieldsproduct });
    }

    getlocationstockproducts(row: any) {
        this.props.get_({
            user_id: this.state.datalogin.id,
            variation_id: row.id,
            typeOption: 'getlocationstockproducts',
            view_active: 'dashboard_products/listProduct',
        }, "api/getlocationstockproducts");
    }

    dismissModalproductsStock() {
        this.props.setData_({
            product_locations_stock: []
        });
    }
    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    render() {
        const { searchText, ModalListStockShow, product_locations_stock, locationsDB, variationsDB, subcategoriesDB, sub_subcategoriesDB, filter_brands, filter_sub_subcategories, filter_subcategories, filter_categories, categoriesDB, brandsDB, alertDestroy, data_pagin_productsDB, formErrors, fieldsproduct, ModalproductShow, categories, subcategories, sub_subcategories, units, brands, products_types } = this.state;
        let data_render_products = [];
        if (data_pagin_productsDB && data_pagin_productsDB.length > 0) {
            data_render_products = [];
            data_render_products = data_pagin_productsDB.map((val: any, key: any) =>
                this.render_products(val, key)
            );
        };

        return (
            <>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    message={'¿Desea eliminar el producto?'}
                    buttons={[
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonPage>
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonButtons slot="start">
                                <IonBackButton defaultHref="/home" text={""} />
                            </IonButtons>
                            <IonTitle>Lista Productos</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent fullscreen scrollEvents={true} style={{ boderRadius: '10px' }}>
                        <IonRow>
                            <IonCol col-6 size='6'>
                                <label>Categoria: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_categories', value: e.value } })}
                                    placeholder="Categoria"
                                    name='filter_categories'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(categoriesDB && categoriesDB.map((value: any) => (
                                            { label: value.name, value: value.id }
                                        )))
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_categories ?
                                        categoriesDB && categoriesDB.length > 0 ?
                                            {
                                                label: categoriesDB.filter((item: any) => item.id == filter_categories)[0].name, value: categoriesDB.filter((item: any) => item.id == filter_categories)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>

                            <IonCol col-6 size='6'>
                                <label>Sub Categoria: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_subcategories', value: e.value } })}
                                    placeholder="Sub Categoria"
                                    name='filter_subcategories'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(Array.isArray(subcategoriesDB)
                                            ? subcategoriesDB.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                            : [])
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_subcategories && filter_subcategories != null && filter_subcategories != '' ?
                                        subcategoriesDB && subcategoriesDB.length > 0 ?
                                            {
                                                label: subcategoriesDB.filter((item: any) => item.id == filter_subcategories)[0].name, value: subcategoriesDB.filter((item: any) => item.id == filter_subcategories)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>

                            <IonCol col-6 size='6'>
                                <label>Sub Categoria 2: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_sub_subcategories', value: e.value } })}
                                    placeholder="Sub Categoria 2"
                                    name='filter_sub_subcategories'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(sub_subcategoriesDB && sub_subcategoriesDB.map((value: any) => (
                                            { label: value.name, value: value.id }
                                        )))
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_sub_subcategories ?
                                        sub_subcategoriesDB && sub_subcategoriesDB.length > 0 ?
                                            {
                                                label: sub_subcategoriesDB.filter((item: any) => item.id == filter_sub_subcategories)[0].name, value: sub_subcategoriesDB.filter((item: any) => item.id == filter_sub_subcategories)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol col-6 size='6'>
                                <label>Marca: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_brands', value: e.value } })}
                                    placeholder="Marca"
                                    name='filter_brands'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[

                                        ...(brandsDB && brandsDB.map((value: any) => (
                                            { label: value.name, value: value.id }
                                        )))
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_brands ?
                                        brandsDB && brandsDB.length > 0 ?
                                            {
                                                label: brandsDB.filter((item: any) => item.id == filter_brands)[0].name, value: brandsDB.filter((item: any) => item.id == filter_brands)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol col-12 size='12' style={{ textAlign: "center", display: "none" }}>
                                <div style={{ display: "none" }}>
                                    <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                                </div>
                            </IonCol>
                            <IonCol col-12 size='12' class='divflex'>
                                <IonIcon icon={search} className='iconseach'></IonIcon>
                                <DebounceInput
                                    className='btn_search'
                                    placeholder={'Código / Nombre del Producto'}
                                    minLength={2}
                                    debounceTimeout={2000}
                                    value={searchText}
                                    onChange={e => this.setSearchText(e)} />
                            </IonCol>
                            <IonCol size='12'>
                                {data_render_products}
                            </IonCol>
                        </IonRow>
                        <IonModal onDidDismiss={this.dismissModalproducts.bind(this)} isOpen={ModalproductShow} ref={this.Modalproduct} trigger="open-modal">
                            <IonContent className="ion-padding">
                                <IonHeader >
                                    <IonToolbar color="primary">
                                        <IonTitle>{fieldsproduct && fieldsproduct.id ? 'Editar Producto' : 'Nuevo Producto'}</IonTitle>
                                        <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalproducts.bind(this)}>
                                            <IonIcon icon={closeOutline}></IonIcon>
                                        </IonButton>
                                    </IonToolbar>
                                </IonHeader>
                                <IonRow>
                                    <IonCol col-12 size='12'>
                                        {
                                            fieldsproduct && fieldsproduct.id == null && fieldsproduct.type === 'single' ? (
                                                <IonAccordionGroup>
                                                    <IonAccordion value="first">
                                                        <IonItem slot="header" color="light">
                                                            <IonLabel><label style={{ fontWeight: 600 }}>Stock de Apertura</label></IonLabel>
                                                        </IonItem>
                                                        <div className="ion-padding" slot="content">
                                                            <div style={{ marginTop: 2 }}>
                                                                <div style={{ border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden' }}>
                                                                    <IonRow style={{ background: '#f7f7f7', padding: '8px 12px', fontWeight: 600 }}>
                                                                        <IonCol size="6">Locación</IonCol>
                                                                        <IonCol size="3">Cantidad</IonCol>
                                                                        <IonCol size="3">Costo ({this.state.currencyprimary ?? ''})</IonCol>
                                                                    </IonRow>

                                                                    {(fieldsproduct && Array.isArray(fieldsproduct.locations) ? fieldsproduct.locations : []).map((loc: any, idx: number) => (
                                                                        <IonRow key={idx} style={{ padding: '8px 12px', alignItems: 'center' }}>
                                                                            <IonCol size="6">
                                                                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                    {loc.location_name ?? loc.name ?? 'Sin nombre'} <br />
                                                                                    {loc.variation_name ?? ''}
                                                                                </div>
                                                                            </IonCol>

                                                                            <IonCol size="3">
                                                                                <input
                                                                                    className="inputform"
                                                                                    type="number"
                                                                                    min={0}
                                                                                    step="0.01"
                                                                                    value={String(loc.quantity ?? 0)}
                                                                                    onFocus={this.handleFocus}
                                                                                    onChange={(e: any) => {
                                                                                        const fieldsproduct = { ...this.state.fieldsproduct };
                                                                                        fieldsproduct.locations = (fieldsproduct.locations || []).map((l: any, i: number) =>
                                                                                            i === idx ? { ...l, quantity: parseFloat(e.target.value) || 0 } : l
                                                                                        );
                                                                                        this.setState({ fieldsproduct });
                                                                                    }}
                                                                                />
                                                                            </IonCol>

                                                                            <IonCol size="3">
                                                                                <input
                                                                                    className="inputform"
                                                                                    type="number"
                                                                                    min={0}
                                                                                    step="0.01"
                                                                                    value={String(loc.purchase_price ?? loc.purchase_price === 0 ? loc.purchase_price : 0)}
                                                                                    onFocus={this.handleFocus}
                                                                                    onChange={(e: any) => {
                                                                                        const fieldsproduct = { ...this.state.fieldsproduct };
                                                                                        fieldsproduct.locations = (fieldsproduct.locations || []).map((l: any, i: number) =>
                                                                                            i === idx ? { ...l, purchase_price: parseFloat(e.target.value) || 0 } : l
                                                                                        );
                                                                                        this.setState({ fieldsproduct });
                                                                                    }}
                                                                                />
                                                                            </IonCol>
                                                                        </IonRow>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </IonAccordion>

                                                </IonAccordionGroup>

                                            ) :
                                                fieldsproduct && fieldsproduct.id != null ? (
                                                    <IonAccordionGroup>
                                                        <IonAccordion value="first">
                                                            <IonItem slot="header" color="light">
                                                                <IonLabel><label style={{ fontWeight: 600 }}>Stock de Apertura</label></IonLabel>
                                                            </IonItem>
                                                            <div className="ion-padding" slot="content">
                                                                <div style={{ marginTop: 2 }}>
                                                                    <div style={{ border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden' }}>
                                                                        <IonRow style={{ background: '#f7f7f7', padding: '8px 12px', fontWeight: 600 }}>
                                                                            <IonCol size="6">Locación</IonCol>
                                                                            <IonCol size="3">Cantidad</IonCol>
                                                                            <IonCol size="3">Costo ({this.state.currencyprimary ?? ''})</IonCol>
                                                                        </IonRow>

                                                                        {(fieldsproduct && Array.isArray(fieldsproduct.locations) ? fieldsproduct.locations : []).map((loc: any, idx: number) => (
                                                                            <IonRow key={idx} style={{ padding: '8px 12px', alignItems: 'center' }}>
                                                                                <IonCol size="6">
                                                                                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                        {loc.location_name ?? loc.name ?? 'Sin nombre'} <br />
                                                                                        {loc.variation_name ?? ''}
                                                                                    </div>
                                                                                </IonCol>

                                                                                <IonCol size="3">
                                                                                    <input
                                                                                        className="inputform"
                                                                                        type="number"
                                                                                        min={0}
                                                                                        step="0.01"
                                                                                        value={String(loc.quantity ?? 0)}
                                                                                        onFocus={this.handleFocus}
                                                                                        onChange={(e: any) => {
                                                                                            const fieldsproduct = { ...this.state.fieldsproduct };
                                                                                            fieldsproduct.locations = (fieldsproduct.locations || []).map((l: any, i: number) =>
                                                                                                i === idx ? { ...l, quantity: parseFloat(e.target.value) || 0 } : l
                                                                                            );
                                                                                            this.setState({ fieldsproduct });
                                                                                        }}
                                                                                    />
                                                                                </IonCol>

                                                                                <IonCol size="3">
                                                                                    <input
                                                                                        className="inputform"
                                                                                        type="number"
                                                                                        min={0}
                                                                                        step="0.01"
                                                                                        value={String(loc.purchase_price ?? loc.purchase_price === 0 ? loc.purchase_price : 0)}
                                                                                        onFocus={this.handleFocus}
                                                                                        onChange={(e: any) => {
                                                                                            const fieldsproduct = { ...this.state.fieldsproduct };
                                                                                            fieldsproduct.locations = (fieldsproduct.locations || []).map((l: any, i: number) =>
                                                                                                i === idx ? { ...l, purchase_price: parseFloat(e.target.value) || 0 } : l
                                                                                            );
                                                                                            this.setState({ fieldsproduct });
                                                                                        }}
                                                                                    />
                                                                                </IonCol>
                                                                            </IonRow>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </IonAccordion>

                                                    </IonAccordionGroup>
                                                ) : null
                                        }

                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Nombre: </label>
                                        <div className="inputWithIcon">
                                            <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                            <input
                                                className='inputform'
                                                type="text"
                                                placeholder="Nombre de la variación"
                                                onChange={this.handleChangeproduct.bind(this)}
                                                value={(fieldsproduct && fieldsproduct.name) ?? ""}
                                                name="name" />
                                        </div>
                                        {formErrors && formErrors.name && (
                                            <>
                                                <IonText color="danger" className="ion-padding-start">
                                                    <small>{formErrors.name}</small>
                                                </IonText>
                                                <br />
                                            </>
                                        )}
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>SKU: </label>
                                        <div className="inputWithIcon">
                                            <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                            <input
                                                className='inputform'
                                                type="text"
                                                placeholder="SKU"
                                                onChange={this.handleChangeproduct.bind(this)}
                                                value={(fieldsproduct && fieldsproduct.sku) ?? ""}
                                                name="sku" />
                                        </div>
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Categoria: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeproduct({ target: { name: 'category_id', value: e.value } })}
                                            placeholder="Categoria"
                                            name='category_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                { label: 'Seleccione', value: null },
                                                ...(categories && categories.map((value: any) => (
                                                    { label: value.name, value: value.id }
                                                )))
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsproduct && fieldsproduct.category_id ?
                                                categories && categories.length > 0 ?
                                                    {
                                                        label: categories.filter((item: any) => item.id == fieldsproduct.category_id)[0].name, value: categories.filter((item: any) => item.id == fieldsproduct.category_id)[0].id
                                                    }
                                                    : { label: 'Seleccione', value: null }
                                                : { label: 'Seleccione', value: null }
                                            }
                                        />
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Sub Categoria: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeproduct({ target: { name: 'sub_category_id', value: e.value } })}
                                            placeholder="Sub Categoria"
                                            name='sub_category_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                { label: 'Seleccione', value: null },
                                                ...(Array.isArray(subcategories)
                                                    ? subcategories.map((value: any) => (
                                                        { label: value.name, value: value.id }
                                                    ))
                                                    : [])
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsproduct && fieldsproduct.sub_category_id ?
                                                subcategories && subcategories.length > 0 ?
                                                    {
                                                        label: subcategories.filter((item: any) => item.id == fieldsproduct.sub_category_id)[0].name, value: subcategories.filter((item: any) => item.id == fieldsproduct.sub_category_id)[0].id
                                                    }
                                                    : { label: 'Seleccione', value: null }
                                                : { label: 'Seleccione', value: null }
                                            }
                                        />
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Sub Categoria 2: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeproduct({ target: { name: 'sub_sub_category_id', value: e.value } })}
                                            placeholder="Sub Categoria 2"
                                            name='sub_sub_category_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                { label: 'Seleccione', value: null },
                                                ...(sub_subcategories && sub_subcategories.map((value: any) => (
                                                    { label: value.name, value: value.id }
                                                )))
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsproduct && fieldsproduct.sub_sub_category_id ?
                                                sub_subcategories && sub_subcategories.length > 0 ?
                                                    {
                                                        label: sub_subcategories.filter((item: any) => item.id == fieldsproduct.sub_sub_category_id)[0].name, value: sub_subcategories.filter((item: any) => item.id == fieldsproduct.sub_sub_category_id)[0].id
                                                    }
                                                    : { label: 'Seleccione', value: null }
                                                : { label: 'Seleccione', value: null }
                                            }
                                        />
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Unidad: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeproduct({ target: { name: 'unit_id', value: e.value } })}
                                            placeholder="Unidad"
                                            name='unit_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[...(units && units.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            )))
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsproduct && fieldsproduct.unit_id ?
                                                units && units.length > 0 ?
                                                    {
                                                        label: units.filter((item: any) => item.id == fieldsproduct.unit_id)[0].name, value: units.filter((item: any) => item.id == fieldsproduct.unit_id)[0].id
                                                    }
                                                    : { label: 'Seleccione', value: null }
                                                : { label: 'Seleccione', value: null }
                                            }
                                        />
                                        {formErrors && formErrors.unit_id && (
                                            <>
                                                <IonText color="danger" className="ion-padding-start">
                                                    <small>{formErrors.unit_id}</small>
                                                </IonText>
                                                <br />
                                            </>
                                        )}
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <label>Marca: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeproduct({ target: { name: 'brand_id', value: e.value } })}
                                            placeholder="Marca"
                                            name='brand_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                ...(brands && brands.map((value: any) => (
                                                    { label: value.name, value: value.id }
                                                )))
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsproduct && fieldsproduct.brand_id ?
                                                brands && brands.length > 0 ?
                                                    {
                                                        label: brands.filter((item: any) => item.id == fieldsproduct.brand_id)[0].name, value: brands.filter((item: any) => item.id == fieldsproduct.brand_id)[0].id
                                                    }
                                                    : { label: 'Ninguna', value: null }
                                                : { label: 'Ninguna', value: null }
                                            }
                                        />
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <IonCheckbox
                                            onIonChange={e => this.handleChangeproduct({ target: { name: 'enable_stock', value: e.detail.checked ? 1 : 0 } })}
                                            checked={fieldsproduct && fieldsproduct.enable_stock && fieldsproduct.enable_stock == 1 ? true : false}
                                            labelPlacement="start" alignment="center">
                                            Administrar Stock
                                        </IonCheckbox>
                                    </IonCol>
                                    {
                                        fieldsproduct && fieldsproduct.id != null && fieldsproduct.id != '' ?
                                            null :
                                            <IonCol col-12 size='12'>
                                                <label>Tipo Producto: </label>
                                                <Select
                                                    className='inputformselect'
                                                    onChange={(e: any) => this.handleChangeproduct({ target: { name: 'type', value: e.value } })}
                                                    placeholder="Tipo Producto"
                                                    name='type'
                                                    menuPortalTarget={document.querySelector('body')}
                                                    isSearchable={false}
                                                    options={[
                                                        ...(products_types && products_types.map((value: any) => (
                                                            { label: value.name, value: value.id }
                                                        )))
                                                    ]}
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                    }}
                                                    defaultValue={fieldsproduct && fieldsproduct.type ?
                                                        products_types && products_types.length > 0 ?
                                                            {
                                                                label: products_types.filter((item: any) => item.id == fieldsproduct.type)[0].name, value: products_types.filter((item: any) => item.id == fieldsproduct.type)[0].id
                                                            }
                                                            : null
                                                        : null
                                                    }
                                                />
                                            </IonCol>
                                    }
                                    {
                                        fieldsproduct && fieldsproduct.type === 'single' ?
                                            <>
                                                <IonCol col-12 size='12'>
                                                    <label>Precio de Compra Unitario: </label>
                                                    <div className="inputWithIcon">
                                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                                        <input
                                                            className='inputform'
                                                            type="text"
                                                            placeholder="Precio de Venta Unitario"
                                                            onChange={this.handleChangeproduct.bind(this)}
                                                            defaultValue={_numberFormat.format(parseFloat((fieldsproduct && fieldsproduct.single_dpp_inc_tax) ?? 0)).replace("$", "")}
                                                            onFocus={this.handleFocus}
                                                            name="single_dpp_inc_tax" />
                                                    </div>
                                                    {formErrors && formErrors.single_dpp_inc_tax && (
                                                        <>
                                                            <IonText color="danger" className="ion-padding-start">
                                                                <small>{formErrors.single_dpp_inc_tax}</small>
                                                            </IonText>
                                                            <br />
                                                        </>
                                                    )}
                                                </IonCol>
                                                <IonCol col-12 size='12'>
                                                    <label>Precio de Venta Unitario: </label>
                                                    <div className="inputWithIcon">
                                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                                        <input
                                                            className='inputform'
                                                            type="text"
                                                            onFocus={this.handleFocus}
                                                            placeholder="Precio de Venta Unitario"
                                                            onChange={this.handleChangeproduct.bind(this)}
                                                            defaultValue={_numberFormat.format(parseFloat((fieldsproduct && fieldsproduct.single_dsp_inc_tax) ?? 0)).replace("$", "")}
                                                            name="single_dsp_inc_tax" />
                                                    </div>
                                                    {formErrors && formErrors.single_dsp_inc_tax && (
                                                        <>
                                                            <IonText color="danger" className="ion-padding-start">
                                                                <small>{formErrors.single_dsp_inc_tax}</small>
                                                            </IonText>
                                                            <br />
                                                        </>
                                                    )}
                                                </IonCol> </> : null
                                    }
                                    {
                                        fieldsproduct && fieldsproduct.type === 'variable' ?
                                            <IonCol col-12 size='12'>
                                                <IonCol col-12 size='12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                                    <h2 style={{ marginBottom: '10px' }}>Variaciones del Producto</h2>
                                                    <IonButton color="secondary" onClick={() => this.addproductvariation()}>Agregar Variación</IonButton>
                                                </IonCol>
                                                {
                                                    fieldsproduct.variations && fieldsproduct.variations.length > 0 ?
                                                        fieldsproduct.variations.map((val: any, key: any) =>
                                                            <IonRow key={key}>
                                                                <IonCol col-12 size='12'>
                                                                    <IonRow style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                                        <IonCol>
                                                                            <strong>Variación {key + 1}</strong>
                                                                        </IonCol>
                                                                        <IonCol size="auto">
                                                                            <IonButton color="danger" size="small" onClick={() => this.deleteproductvariation(key)}>
                                                                                <IonIcon slot="start" icon={trashOutline} />
                                                                                Eliminar
                                                                            </IonButton>
                                                                        </IonCol>
                                                                    </IonRow>
                                                                </IonCol>
                                                                <IonCol col-6 size='6'>
                                                                    <label>Variación: </label>
                                                                    <Select
                                                                        className='inputformselect'
                                                                        onChange={(e: any) => this.handleChangeproductvariation({ target: { name: 'variation_id', value: e.value, key: key } })}
                                                                        placeholder="Variación"
                                                                        name='variation_id'
                                                                        menuPortalTarget={document.querySelector('body')}
                                                                        isSearchable={false}
                                                                        options={[
                                                                            ...(variationsDB && variationsDB.map((value: any) => (
                                                                                { label: value.name, value: value.id }
                                                                            )))
                                                                        ]}
                                                                        styles={{
                                                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                                        }}
                                                                        defaultValue={val && val.variation_id ?
                                                                            variationsDB && variationsDB.length > 0 ?
                                                                                {
                                                                                    label: variationsDB.filter((item: any) => item.id == val.variation_id)[0].name, value: variationsDB.filter((item: any) => item.id == val.variation_id)[0].id
                                                                                }
                                                                                : null
                                                                            : null
                                                                        }
                                                                    />
                                                                </IonCol>
                                                                <IonCol col-6 size='6'>
                                                                    <label>Valores: </label>
                                                                    <Select
                                                                        className='inputformselect'
                                                                        onChange={(e: any) => this.handleChangeproductvariation({ target: { name: 'values_variations', value: e, key: key } })}
                                                                        placeholder={(val && Array.isArray(val.values) && val.values.length > 0) ? "Valores" : "Sin valores disponibles"}
                                                                        name='values_variations'
                                                                        menuPortalTarget={document.querySelector('body')}
                                                                        isSearchable={false}
                                                                        isMulti={true}
                                                                        options={
                                                                            (val && Array.isArray(val.values) && val.values.length > 0)
                                                                                ? val.values.map((value: any) => ({ label: value.name, value: value.id }))
                                                                                : []
                                                                        }
                                                                        isDisabled={!(val && Array.isArray(val.values) && val.values.length > 0)}
                                                                        styles={{
                                                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                                        }}
                                                                        defaultValue={(val && Array.isArray(val.values_edit) && val.values_edit.length > 0)
                                                                            ? val.values_edit.map((value: any) => ({ label: value.label, value: value.value }))
                                                                            : []
                                                                        }
                                                                    />
                                                                </IonCol>
                                                                {
                                                                    val && val.values_variations && val.values_variations.length > 0 ?
                                                                        val.values_variations.map((val_value: any, key_value: any) =>
                                                                            <IonCol col-12 size='12'>
                                                                                <IonRow key={key_value} style={{ border: '1px solid #ccc', marginBottom: '10px', padding: '10px', borderRadius: '5px' }}    >
                                                                                    <IonCol col-12 size='12'>
                                                                                        <strong>{val_value.label}</strong>
                                                                                    </IonCol>
                                                                                    <IonCol col-6 size='6'>
                                                                                        <label>Precio de Compra Unitario: </label>
                                                                                        <div className="inputWithIcon">
                                                                                            <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                                                                            <input
                                                                                                className='inputform'
                                                                                                type="text"
                                                                                                placeholder="Precio de Venta Unitario"
                                                                                                onFocus={this.handleFocus}
                                                                                                onChange={(e: any) => this.handleChangeproductvariation({ target: { name: 'dpp_inc_tax', value: e.target.value, key: key, key_value: key_value } })}
                                                                                                defaultValue={_numberFormat.format(parseFloat((val_value.dpp_inc_tax) ?? 0)).replace("$", "")}
                                                                                                name="dpp_inc_tax" />
                                                                                        </div>
                                                                                    </IonCol>
                                                                                    <IonCol col-6 size='6'>
                                                                                        <label>Precio de Venta Unitario: </label>
                                                                                        <div className="inputWithIcon">
                                                                                            <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                                                                            <input
                                                                                                className='inputform'
                                                                                                type="text"
                                                                                                placeholder="Precio de Venta Unitario"
                                                                                                onFocus={this.handleFocus}
                                                                                                onChange={(e: any) => this.handleChangeproductvariation({ target: { name: 'dsp_inc_tax', value: e.target.value, key: key, key_value: key_value } })}
                                                                                                defaultValue={_numberFormat.format(parseFloat((val_value.dsp_inc_tax) ?? 0)).replace("$", "")}
                                                                                                name="dsp_inc_tax" />
                                                                                        </div>
                                                                                    </IonCol>
                                                                                </IonRow>
                                                                            </IonCol>
                                                                        ) : null
                                                                }
                                                            </IonRow>
                                                        ) : null
                                                }
                                            </IonCol>
                                            : null
                                    }
                                </IonRow>
                            </IonContent>
                            <IonFooter collapse="fade" className='footerfixed'>
                                <IonToolbar>
                                    <IonButtons slot="start">
                                        <IonButton color="dark" onClick={() => this.dismissModalproducts()}>
                                            Cancel
                                        </IonButton>
                                    </IonButtons>
                                    <IonButtons slot="end">
                                        <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                            Guardar
                                        </IonButton>
                                    </IonButtons>
                                </IonToolbar>
                            </IonFooter>
                        </IonModal>
                        <IonModal onDidDismiss={this.dismissModalproductsStock.bind(this)} isOpen={ModalListStockShow} ref={this.ModalListStockShow} trigger="open-modal">
                            <IonContent className="ion-padding">
                                <IonHeader >
                                    <IonToolbar color="primary">
                                        <IonTitle>{'STOCK'}</IonTitle>
                                        <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalproductsStock.bind(this)}>
                                            <IonIcon icon={closeOutline}></IonIcon>
                                        </IonButton>
                                    </IonToolbar>
                                </IonHeader>
                                <IonRow>
                                    {product_locations_stock && product_locations_stock.length > 0 ? (
                                        product_locations_stock.map((loc: any, idx: number) => (
                                            <IonCol col-12 size='12' key={idx}>
                                                <IonItem>
                                                    <IonRow style={{ width: '100%' }}>
                                                        <IonCol size="6">
                                                            <div style={{ fontWeight: 300 }}>{loc.name ?? '—'}</div>
                                                            <div style={{ fontSize: 15, color: '#666' }}>{loc.pname ?? '—'}</div>
                                                        </IonCol>
                                                        <IonCol size="6" className="ion-text-right">
                                                            <div>Cantidad : {_numberFormat.format(loc.qty_available ?? '0').replace("$", '')}</div>
                                                        </IonCol>
                                                    </IonRow>
                                                </IonItem>
                                            </IonCol>
                                        ))
                                    ) : (
                                        <IonCol col-12 size='12'>
                                            <div>No hay stock disponible</div>
                                        </IonCol>
                                    )}
                                </IonRow>
                            </IonContent>
                            <IonFooter collapse="fade" className='footerfixed'>
                                <IonToolbar>
                                    <IonButtons slot="start">
                                        <IonButton color="dark" onClick={() => this.dismissModalproductsStock()}>
                                            Cancel
                                        </IonButton>
                                    </IonButtons>

                                </IonToolbar>
                            </IonFooter>
                        </IonModal>
                        <div
                            style={{
                                position: 'fixed',
                                bottom: '16px',
                                right: '16px',
                                zIndex: 100
                            }}
                        >
                            <IonFabButton onClick={(e) => this.openModalproducts(e, null)} color="primary">
                                <IonIcon icon={add}></IonIcon>
                            </IonFabButton>
                        </div>
                        <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                            onIonInfinite={(event) => {
                                this.getDataPaginInit();
                            }}
                        >
                            <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                        </IonInfiniteScroll>
                    </IonContent >

                </IonPage >
            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ProductActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ProductActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ProductActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(listProduct);
